// extracted by mini-css-extract-plugin
module.exports = {"terms":"PostBookingPaymentInner-desktop-module__terms___TDVhu","root":"PostBookingPaymentInner-desktop-module__root___lM5Xl"};